import React, {memo} from 'react';

import {getLocation} from 'app/utils/urls';

import {
  ReplaceableLink,
  OwnProps as ReplaceableLinkProps,
} from './ReplaceableLink';

export type FullHTMLLinkToType =
  | string
  | {
      pathname: string;
      search?: string;
      hash?: string;
      state?: Record<string, unknown>;
    }
  | (() => string);

export interface Props extends Omit<ReplaceableLinkProps, 'to'> {
  html_url?: string;
  renderRegularLink?: boolean;
  to?: FullHTMLLinkToType;
}

export const FullHTMLLink = memo<Props>(
  ({
    html_url,
    children,
    renderRegularLink = false,
    ...others
  }: Props): JSX.Element => {
    const link = getLocation(html_url);
    const completeLink = link.pathname + link.search + link.hash;

    return renderRegularLink ? (
      <a {...others} href={completeLink}>
        {children}
      </a>
    ) : (
      <ReplaceableLink to={completeLink} {...others}>
        {children}
      </ReplaceableLink>
    );
  }
);

export {ReplaceableLink};
